
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'placeHolderTableCellStyle': {'border': `none`,'padding': `0`,'width': `28px`,},'bodyTableCellStyle': {'paddingTop': `54px`,'paddingLeft': `20px`,'paddingRight': `20px`,'paddingBottom': `31px`,},'existingPaymentOptions': {'display': `flex`,'flexDirection': `row`,'flexWrap': `wrap`,},'selected': {'background': `#49B84C`,'color': `#D9F0DA`,},'paymentMethodName': {'fontFamily': `'Lemon-Regular', sans-serif`,'fontSize': `20px`,'fontWeight': `bold`,'textAlign': `center`,},
        
      };
    };
  